<template>
  <section>
    <Divider class="mt-4 mb-4 bg-delta-grey" v-show="canWatchBasic" />
    <form v-show="canWatchBasic">
      <FormRow :fieldNameArr="[$t('GROUP_ACCOUNT'), $t('ROLE'), $t('SYSTEM')]">
        <Input v-model="group.code" :disabled="true" slot="a" />
        <Select v-model="roleCode" slot="b">
          <Option v-for="(item, index) in deltaRoleList" :value="item.code" :key="index">
            {{ item.code }}
          </Option>
        </Select>
        <Input v-model="system" :disabled="true" slot="c" />
      </FormRow>

      <FormRow :fieldNameArr="[$t('NAME')]">
        <Input v-model="group.name" class="longText" :disabled="!canUpdateBasic" slot="a" />
      </FormRow>

      <FormRow :fieldNameArr="[$t('GO_LIVE_DATE'), $t('CREATE_DATE'), $t('STATUS')]">
        <DatePicker
          v-model="group.effectiveDate"
          type="date"
          format="yyyy-MM-dd"
          :placeholder="$t('GO_LIVE_DATE')"
          :disabled="!canUpdateBasic"
          @on-change="changeEffectiveDate"
          slot="a"
        ></DatePicker>
        <Input v-model="group.createDate" :disabled="true" slot="b" />
        <RadioGroup v-model="group.isLock" size="large" slot="c">
          <Radio label="true" :disabled="!canUpdateBasic">LOCK</Radio>
          <Radio label="false" :disabled="!canUpdateBasic">UNLOCK</Radio>
        </RadioGroup>
      </FormRow>

      <FormRow :fieldNameArr="[$t('REMARK')]">
        <Input
          v-model="group.remarks"
          class="longText"
          :maxlength="500"
          show-word-limit
          :disabled="!canUpdateBasic"
          :style="{width: 500 + 'px'}"
          slot="a"
        />
      </FormRow>

      <FormRow :fieldNameArr="[$t('REGION')]">
        <CheckboxGroup v-model="group.regionCodeList" size="large" slot="a">
          <Checkbox v-for="(item, index) in regionList" :key="index" :label="item.code" :disabled="!canUpdateBasic">
            {{ language == "en" ? item.name : item.description }}
          </Checkbox>
        </CheckboxGroup>
      </FormRow>

      <Card :title="$t('SPECIAL_SETTINGS')" class="card-warning mt-3">
        <div class="flex-container">
          <div v-for="(specialFlagRole, index) in specialFlagRoleList" :key="index">
            <div class="item">
              <div class="inline">
                <span class="label"> {{ specialFlagRole.name }} </span>
              </div>
              <div class="inline">
                <i-switch
                  v-model="specialFlagRole.checked"
                  size="large"
                  true-value="Y"
                  false-value="N"
                  :disabled="!canUpdateBasic"
                  slot="a"
                >
                  <span slot="open">{{$t('YES')}}</span>
                  <span slot="close">{{$t('NO')}}</span>
                </i-switch>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </form>
    <ButtonRow v-show="canUpdateBasic" >
      <Button type="primary" @click="createGroupAccount" slot="0" v-if="!isUpdate">{{$t('CREATE_ACCOUNT')}}</Button>
      <Button type="primary" @click="updateGroupAccount" slot="1" v-if="isUpdate">{{$t('UPDATE_ACCOUNT')}}</Button>
    </ButtonRow>
    <Divider class="mt-4 mb-4 bg-delta-grey" v-show="!canUpdateBasic && canWatchBasic" />
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"

export default {
  name: "DeltaPart",
  props: {
    group: {
      type: Object,
      default: () => null,
    },
    regionList: {
      type: Array,
      default: () => null,
    },
    checkSpecialFlagRole: {
      type: Array,
      default: () => null,
    },
    specialFlagRoleList: {
      type: Array,
      default: () => []
    },
    isUpdate: {
      type: Boolean,
      default: () => false,
    },
    noGroupAccoutShow: {
      type: Boolean,
      default: () => false,
    },
    roleList: {
      type: Array,
      default: () => []
    },
    system: {
      type: String,
      default: () => "E-Procurement(EC) System"
    }
  },
  created() {
    if (!this.noGroupAccoutShow) {
      this.toggleLoading(true)
      this.$authHttp
        .post(
          "role/search/attribute",
          JSON.stringify({
            attributeDtos: [
              {
                key: "GROUP_PERSON",
                value: "Group",
              },
              {
                key: "SPECIAL_FLAG",
                value: "Delta",
              },
            ],
            paged: false,
          })
        )
        .then((response) => {
          this.toggleLoading(false)
          response.data._embedded.roleResourceList.forEach(roleResource => {
            this.specialFlagRoleList.push(roleResource);
          });
          this.specialFlagRoleList.forEach((role) => {
            if (this.checkSpecialFlagRole.includes(role.code)) {
              role.checked = "Y"
            } else {
              role.checked = "N"
            }
          })
        })
        .catch(() => {})

      this.roleCode = this.group.role.code;
      this.group.regionCodeList = [];
      this.group.isLock = this.group.isLock === undefined ? "false" : this.group.isLock.toString();
      if (this.group.regions != undefined && this.group.regions != null) {
        this.group.regions.forEach(region => {
          this.group.regionCodeList.push(region.code);
        });
      }
      this.deltaRoleList = this.roleList.filter(role => {
        return !role.attributes.some(attribute => attribute.key == 'CHECK_ERP' && attribute.value =='Y');
      });
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage"]),
    ...mapActions(["toggleLoading"]),
    changeEffectiveDate(value) {
      this.$emit("changeEffectiveDate", value)
    },
    async createGroupAccount() {
      let data = {
        code: this.group.code,
        name: this.group.name,
        effectiveDate: this.group.effectiveDate,
        isLock: this.group.isLock,
        remarks: this.group.remarks,
        regionCodeList: this.group.regionCodeList
      };
      this.$emit("createGroupAccount", data);
    },
    async updateGroupAccount() {
      let data = {
        name: this.group.name,
        effectiveDate: this.group.effectiveDate,
        isLock: this.group.isLock,
        remarks: this.group.remarks,
        regionCodeList: this.group.regionCodeList,
        isCheckErp: this.group.role.attributes.find(attr => attr.key === "CHECK_ERP").value === "Y"
      };
      this.$emit("updateGroupAccount", data, this.roleCode);
    }
  },
  computed: {
    language() {
      return this.getLanguage()
    },
    canUpdateBasic() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_CREATE_GROUP_ACCOUNT_AREA")
      )
    },
    canWatchBasic() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_SEARCH_GROUP_ACCOUNT_AREA")
      )
    },
  },
}
</script>

<style scoped></style>
